import React, { createContext } from 'react';
import { IntlShape } from 'react-intl';

import {
  ILangeFormatMsg,
  langFormatMsg,
} from '../../components/lang-format-msg';

interface I18nContextType {
  fm: ILangeFormatMsg;
  locale: string;
}

const I18nContext = createContext<I18nContextType>({
  fm: null,
  locale: null,
});

interface I18ProviderProps {
  intl: IntlShape;
  locale: string;
}

const I18nProvider: React.FC<I18ProviderProps> = ({
  intl,
  children,
  locale,
}) => {
  const fm = langFormatMsg(intl.formatMessage);

  return (
    <I18nContext.Provider value={{ fm, locale }}>
      {children}
    </I18nContext.Provider>
  );
};

const useI18n = () => {
  return React.useContext(I18nContext);
};

export { I18nProvider, I18nContext, useI18n };
